export enum OptionalService {
  OptionalServiceId = "OptionalServiceId",
  LessorData = "LessorData",
  LessorType = "LessorType",
  LessorName = "LessorName",
  LessorEmail = "LessorEmail",
  LessorMailSentDate = "LessorMailSentDate",
  AlreadyInHousing = "AlreadyInHousing",
  CustomerReference = "CustomerReference",
  MainSiteNumber = "MainSiteNumber",
}
